import React, { Fragment, useState, useEffect } from "react";
import Breadcrumb from "../../component/common/breadcrumb/breadcrumb";
import {
    Container,
    Row,
    Col,
    Card,
    CardHeader,
    CardBody,
    Button,
    Modal,
    ModalHeader,
    ModalBody,
    ModalFooter,
    Input,
} from "reactstrap";
import axios from "axios";
import { toast } from "react-toastify";
import DataTable from "datatables.net-react";
import DT from "datatables.net-bs5";
import "datatables.net";
import "datatables.net-bs5";
import "datatables.net-responsive";
import "datatables.net-responsive-bs5";
import "datatables.net-bs5/css/dataTables.bootstrap5.css";
import "datatables.net-responsive-bs5/css/responsive.bootstrap5.css";
import ReactDOM from "react-dom";

DataTable.use(DT);

const Notification = ({ id_user }) => {
    const [notifications, setNotifications] = useState([]);
    const token = localStorage.getItem("token");
    const valetId = localStorage.getItem("valetId");
    const [modalOpen, setModalOpen] = useState(false);
    const [etaMinutes, setEtaMinutes] = useState("");
    const [currentNotificationId, setCurrentNotificationId] = useState(null);

    useEffect(() => {
        const fetchNotifications = async () => {
            try {
                const response = await axios.get(
                    `${process.env.REACT_APP_PUBLIC_SERVER}/api/notifications/valet/${valetId}`,
                    {
                        headers: { Authorization: `Bearer ${token}` },
                    }
                );
                setNotifications(response.data);
            } catch (error) {
                toast.error("Error al cargar las notificaciones.");
            }
        };
        fetchNotifications();
    }, [valetId, token]);

    const openEtaModal = (notificationId) => {
        setCurrentNotificationId(notificationId);
        setModalOpen(true);
        setEtaMinutes("");
    };

    const confirmMarkAsRead = async () => {
        const minutes = parseInt(etaMinutes, 10);
        if (isNaN(minutes) || minutes < 1 || minutes > 60) {
            toast.error("Por favor, ingresa un valor entre 1 y 60 minutos.");
            return;
        }

        const now = new Date();
        const eta = new Date(now.getTime() + minutes * 60000);
        const formattedEta = eta.toISOString().slice(0, 19).replace('T', ' ');

        try {
            await axios.put(
                `${process.env.REACT_APP_PUBLIC_SERVER}/api/notifications/${currentNotificationId}`,
                {
                    id_user: id_user,
                    is_read: 1,
                    eta: formattedEta
                },
                { headers: { Authorization: `Bearer ${token}` } }
            );
            setNotifications(notifications.filter((n) => n.id !== currentNotificationId));
            toast.success("Notificación marcada como leída y ETA enviado.");
            setModalOpen(false);
        } catch (error) {
            console.error("Error al marcar como leída:", error);
            toast.error("Error al procesar la notificación.");
        }
    };

    const columns = [
        { title: "ID", data: "id" },
        { title: "Mensaje", data: "message" },
        {
            title: "Acción",
            data: null,
            createdCell: (td, cellData, rowData) => {
                const button = (
                    <Button
                        color="success"
                        size="sm"
                        onClick={() => openEtaModal(rowData.id)}
                    >
                        Marcar como leída
                    </Button>
                );
                const root = ReactDOM.createRoot(td);
                root.render(button);
            },
        },
    ];

    return (
        <Fragment>
            <Breadcrumb parent="Dashboard" title="Notificaciones" />
            <Container fluid={true}>
                <Row>
                    <Col sm="12">
                        <Card>
                            <CardHeader>
                                <h2>Notificaciones</h2>
                            </CardHeader>
                            <CardBody>
                                {notifications.length === 0 ? (
                                    <p>No hay notificaciones nuevas.</p>
                                ) : (
                                    <DataTable
                                        data={notifications}
                                        columns={columns}
                                        className="table table-striped nowrap"
                                        style={{ width: "100%" }}
                                        options={{
                                            responsive: true
                                        }}
                                    />
                                )}
                            </CardBody>
                        </Card>
                    </Col>
                </Row>
            </Container>
            <Modal isOpen={modalOpen} toggle={() => setModalOpen(false)}>
                <ModalHeader toggle={() => setModalOpen(false)}>Seleccionar ETA (minutos)</ModalHeader>
                <ModalBody>
                    <Input
                        type="number"
                        min="1"
                        max="60"
                        value={etaMinutes}
                        onChange={(e) => setEtaMinutes(e.target.value)}
                        placeholder="Ingresa los minutos (1-60)"
                    />
                </ModalBody>
                <ModalFooter>
                    <Button color="primary" onClick={confirmMarkAsRead}>
                        Confirmar
                    </Button>
                    <Button color="secondary" onClick={() => setModalOpen(false)}>
                        Cancelar
                    </Button>
                </ModalFooter>
            </Modal>
        </Fragment>
    );
};

export default Notification;